import { useMemo } from 'react';
import { EmployeeSize } from '@/assets/icons/filters';
import {
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { KText } from '@/ui-library/components/text';
import { FaRegEyeSlash } from 'react-icons/fa';

export const NotesAccessMenu = ({
  selected: defaultSelected = 'public',
  setSelected = () => {},
  isEditable = true,
  isShared = false,
  reference = '',
}) => {
  const notesMenuConfig = useMemo(
    () => [
      {
        id: 'public',
        label: 'Public',
        icon: EmployeeSize,
      },
      ...(isShared
        ? [
            {
              id: 'shared',
              label: 'Public (Shared with Interviewers)',
              icon: EmployeeSize,
            },
          ]
        : []),
      {
        id: 'private',
        label: 'Private',
        icon: FaRegEyeSlash,
      },
    ],
    [isShared]
  );

  const selected = notesMenuConfig?.find(
    (item) => item?.id === defaultSelected
  );
  const others = notesMenuConfig?.filter(
    (item) => item?.id !== defaultSelected
  );

  if (!isEditable)
    return (
      <Flex alignItems="center" gap="6px">
        <Icon as={selected?.icon} />
        <KText size="sm-medium">{selected?.label}</KText>
      </Flex>
    );

  return (
    <Menu>
      <MenuButton>
        <Flex alignItems="center" gap={reference === '' ? '6px' : '0px'}>
          <Icon as={selected?.icon} verticalAlign="top" />
          {reference === '' && (
            <KText size="sm-medium">{selected?.label}</KText>
          )}
          <Icon as={ChevronDownIcon} verticalAlign="top" />
        </Flex>
      </MenuButton>
      <MenuList>
        {others?.map((item) => (
          <MenuItem key={item?.id} onClick={() => setSelected(item?.id)}>
            <Flex gap="6px" alignItems="center">
              <Icon as={item?.icon} />
              <KText size="sm-medium">{item?.label}</KText>
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
